import { getSetupCosts } from '~/utils/cost-calculator'
import { pluralize } from '~/utils/string'

const DECIMALS = 2
const DECIMALS_WITH_DOT = 3

export const generateMonthlyCosts = (cost, suffix = 'p/m') => {
  if (cost.monthly?.length > 0) {
    const { amount } = cost.monthly[0]
    return `£${amount.toFixed(DECIMALS)} ${suffix}`
  }

  return null
}

export const getMonthlyCost = (cost) => {
  if (cost.monthly?.length > 0) {
    const formatted = cost.monthly[0].amount.toFixed(DECIMALS)

    return [formatted.slice(0, -DECIMALS_WITH_DOT), formatted.substr(-DECIMALS_WITH_DOT, DECIMALS_WITH_DOT)]
  }

  return '-'
}

export const generateDiscountedPeriod = (cost) => {
  if (cost.monthly?.length > 1) {
    const { start, end } = cost.monthly[0]
    const duration = end + 1 - start
    return `for ${duration} ${pluralize('month', duration)}`
  }

  return null
}

export const generateThereafterMonthlyCosts = (cost) => {
  if (cost.monthly?.length > 1) {
    const { amount } = cost.monthly[1]
    return `£${amount.toFixed(DECIMALS)} thereafter`
  }

  return null
}

export const getDurationAndCostThereafter = (cost) => {
  if (cost.monthly?.length > 1) {
    const { start, end } = cost.monthly[0]
    const { amount } = cost.monthly[1]
    const duration = end + 1 - start

    return {
      duration: `for ${duration} ${pluralize('month', duration)} then`,
      costThereafter: `£${amount.toFixed(DECIMALS)}`
    }
  }

  return null
}

export const generateSetupCosts = (cost) =>
  cost.upfront > 0 ? `${getSetupCosts(cost.upfront)} setup` : `no setup cost`

export const getSetupCost = ({ upfront }) => (upfront > 0 ? `${getSetupCosts(upfront)} setup cost` : `no setup cost`)

export const splitData = (text) => {
  const textToLowerCase = text.toLowerCase()
  if (textToLowerCase.includes('unlimited') || textToLowerCase.includes('free')) {
    return {
      leftText: text,
      rightText: ''
    }
  }

  // Matches all the letters, while ignoring digits or special characters
  const expression = /[a-zA-z/]+/g

  // Find unit in a string, like MB or Mbps
  const unit = text.match(expression)

  // Find value in a string, like 80 or 80-100
  const value = text.split(expression)

  return {
    leftText: value ? value[0] : '',
    rightText: unit ? unit[0] : ''
  }
}
